import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

interface AggCardProps {
  processing: any;
  processed: any;
}

const AggCardTag: React.FC<AggCardProps> = ({ processing, processed }) => {
  return (
    <View style={styles.container}>
      <View style={styles.itemContainer}>
        <Text variant="caption_2" style={styles.title}>
          {processing?.title}
        </Text>
        <Text variant="title_16" numberOfLines={1} style={styles.amount}>
          {processing?.value}
        </Text>
      </View>
      <View style={styles.divider} />
      <View style={styles.itemContainer}>
        <Text variant="caption_2" style={styles.title}>
          {processed?.title}
        </Text>
        <Text variant="title_16" numberOfLines={1} style={styles.amount}>
          {processed?.value}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: color.white,
    paddingHorizontal: 4,
    borderRadius: 4,
    borderColor: "#e0e0e0",
    borderWidth: 1,
    justifyContent: "space-evenly",
    alignContent: "flex-end",
    right: 16,
  },
  itemContainer: {
    alignContent: "center",
    maxWidth: 65,
    minWidth: 50,
    alignItems: "center",
  },
  amount: {
    lineHeight: 20,
  },
  divider: {
    width: 1,
    height: "80%",
    backgroundColor: "#e0e0e0",
    marginHorizontal: 4,
  },
  title: {
    color: color.mediumBlacklightBlack,
  },
});

export default AggCardTag;
